document.addEventListener("DOMContentLoaded", function () {
  // Shopify can inject policy navigation independently of the theme sidebar.
  // Remove the two policies this storefront does not expose.
  if (document.body.classList.contains("page-type-policy")) {
    document.querySelectorAll('a[href*="/policies/refund-policy"], a[href*="/policies/shipping-policy"]').forEach(function (link) {
      var row = link.closest("li");
      if (row) {
        row.remove();
      } else {
        link.remove();
      }
    });
  }

  // bag page: "remove" zeroes the qty field and submits the cart form
  document.querySelectorAll(".bag-line-remove").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var key = btn.dataset.removeKey;
      var input = document.getElementById("bag-qty-" + key);
      if (!input) return;
      input.value = 0;
      var form = btn.closest("form");
      if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
    });
  });

  var grid = document.getElementById("grid");
  if (!grid) return;

  var cells = [].slice.call(grid.querySelectorAll(".cell"));
  var clearBtn = document.getElementById("clear");
  var count = document.getElementById("count");
  var chips = [].slice.call(document.querySelectorAll(".chip"));
  var picked = [];

  function pad(n) {
    return (n < 10 ? "0" : "") + n;
  }

  function applyFilter() {
    var shown = 0;
    var pending = 0;

    cells.forEach(function (cell) {
      var stock = (cell.dataset.stock || "").split(",").filter(Boolean);
      var productAvailable = cell.dataset.productAvailable === "true";
      var isPending = stock.length === 0;
      var match =
        picked.length === 0 ||
        stock.some(function (s) {
          return picked.indexOf(s) > -1;
        });

      cell.hidden = !match;

      if (match) {
        if (isPending && !productAvailable) {
          pending++;
        } else {
          shown++;
        }
      }
    });

    if (clearBtn) clearBtn.hidden = picked.length === 0;

    if (count) {
      count.textContent = picked.length
        ? pad(shown) + " match " + picked.join("/")
        : shown > 0 ? "in stock" : (pending ? pad(pending) + " pending" : "out of stock");
    }

    var empty = grid.querySelector(".empty-filtered");
    if (shown === 0 && pending === 0 && cells.length > 0) {
      if (!empty) {
        empty = document.createElement("div");
        empty.className = "empty empty-filtered";
        empty.textContent = "nothing in that size \u2014 try the list";
        grid.appendChild(empty);
      }
    } else if (empty) {
      empty.remove();
    }
  }

  chips.forEach(function (chip) {
    chip.addEventListener("click", function () {
      var s = chip.dataset.size;
      var i = picked.indexOf(s);
      if (i > -1) {
        picked.splice(i, 1);
        chip.setAttribute("aria-pressed", "false");
      } else {
        picked.push(s);
        chip.setAttribute("aria-pressed", "true");
      }
      applyFilter();
    });
  });

  if (clearBtn) {
    clearBtn.addEventListener("click", function () {
      picked.length = 0;
      chips.forEach(function (c) {
        c.setAttribute("aria-pressed", "false");
      });
      applyFilter();
    });
  }

  applyFilter();
});
